(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["cart"]) return;
  try {
    
  (() => {
    const renderCart = async (root, cart, sectionId, cartPage) => {
      let markup = cart.sections?.[sectionId];
      if (!markup) {
        const url = new URL(cartPage, window.location.origin);
        url.searchParams.set('section_id', sectionId);
        const response = await fetch(url, { credentials: 'same-origin' });
        if (!response.ok) throw new Error('Cart section unavailable');
        markup = await response.text();
      }
      const next = new DOMParser().parseFromString(markup, 'text/html').querySelector('.neptune-cart');
      if (!next) throw new Error('Cart section missing');
      const note = root.querySelector('#CartNote')?.value;
      root.replaceWith(next);
      if (note !== undefined) {
        const nextNote = next.querySelector('#CartNote');
        if (nextNote) nextNote.value = note;
      }
      const cartLink = document.querySelector('.site-header__cart');
      if (cartLink) {
        const badge = cartLink.querySelector('span[aria-hidden="true"]');
        if (badge) badge.textContent = cart.item_count;
        const template = cart.item_count === 1 ? cartLink.dataset.cartCountOne : cartLink.dataset.cartCountOther;
        if (template) cartLink.setAttribute('aria-label', template.replace('COUNT_PLACEHOLDER', cart.item_count));
      }
      next.classList.add('neptune-cart--updated');
      initializeCart(next);
      return next;
    };

    const initializeCart = (root) => {
      const form = root.querySelector('#NeptuneCartForm');
      if (!form || !window.fetch) return;
      form.classList.add('neptune-cart__form--enhanced');
      const status = root.querySelector('[data-cart-status]');
      const checkout = form.querySelector('[name="checkout"]');
      const pending = new Map();
      let timer;
      let inFlight = false;
      let enhanced = true;

      const setStatus = (message, error = false) => {
        if (!status) return;
        status.textContent = message;
        if (error) status.dataset.error = '';
        else delete status.dataset.error;
      };

      const setBusy = (busy) => {
        form.setAttribute('aria-busy', String(busy));
        form.querySelectorAll('.neptune-cart__stepper button, .neptune-cart__stepper input').forEach((control) => {
          control.disabled = busy || (control.dataset.cartStep === '-1' && Number(control.parentElement.querySelector('input').value) <= 1);
        });
        if (checkout) checkout.disabled = busy || pending.size > 0;
      };

      const flush = async () => {
        clearTimeout(timer);
        if (inFlight || pending.size === 0) return;
        inFlight = true;
        const changes = [...pending].sort((a, b) => b[0] - a[0]);
        pending.clear();
        const active = document.activeElement;
        const focusLine = active?.closest('[data-cart-line]')?.dataset.cartLine;
        const focusStep = active?.dataset.cartStep;
        changes.forEach(([line]) => root.querySelector(`[data-cart-line="${line}"]`)?.setAttribute('data-cart-pending', ''));
        setBusy(true);
        setStatus(root.dataset.cartUpdating);
        let lastCart;
        try {
          const cartRoot = window.Shopify?.routes?.root || root.dataset.cartRoot || '/';
          const changeUrl = `${cartRoot.replace(/\/?$/, '/')}cart/change.js`;
          for (const [line, quantity] of changes) {
            const response = await fetch(changeUrl, {
              method: 'POST',
              credentials: 'same-origin',
              headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
              body: JSON.stringify({ line, quantity, sections: root.dataset.cartSectionId, sections_url: root.dataset.cartPage })
            });
            lastCart = await response.json();
            if (!response.ok) throw new Error(lastCart.description || root.dataset.cartUpdateError);
          }
          const next = await renderCart(root, lastCart, root.dataset.cartSectionId, root.dataset.cartPage);
          requestAnimationFrame(() => {
            const nextStatus = next.querySelector('[data-cart-status]');
            if (nextStatus) {
              nextStatus.textContent = next.dataset.cartUpdated;
              setTimeout(() => {
                if (nextStatus.textContent === next.dataset.cartUpdated) nextStatus.textContent = '';
              }, 2500);
            }
          });
          if (focusLine) {
            const focusTarget = next.querySelector(`[data-cart-line="${focusLine}"] ${focusStep ? `[data-cart-step="${focusStep}"]` : 'input[name="updates[]"]'}`);
            focusTarget?.focus({ preventScroll: true });
          }
        } catch (error) {
          try {
            const response = await fetch(root.dataset.cartPage, { credentials: 'same-origin' });
            if (!response.ok) throw new Error('Cart unavailable');
            const page = new DOMParser().parseFromString(await response.text(), 'text/html');
            const fresh = page.querySelector('.neptune-cart');
            if (!fresh) throw new Error('Cart missing');
            const note = root.querySelector('#CartNote')?.value;
            root.replaceWith(fresh);
            if (note !== undefined && fresh.querySelector('#CartNote')) fresh.querySelector('#CartNote').value = note;
            const freshCartLink = page.querySelector('.site-header__cart');
            const currentCartLink = document.querySelector('.site-header__cart');
            if (freshCartLink && currentCartLink) {
              currentCartLink.setAttribute('aria-label', freshCartLink.getAttribute('aria-label'));
              const freshBadge = freshCartLink.querySelector('span[aria-hidden="true"]');
              const currentBadge = currentCartLink.querySelector('span[aria-hidden="true"]');
              if (freshBadge && currentBadge) currentBadge.textContent = freshBadge.textContent;
            }
            initializeCart(fresh);
            const freshStatus = fresh.querySelector('[data-cart-status]');
            if (freshStatus) {
              freshStatus.dataset.error = '';
              freshStatus.textContent = error.message || fresh.dataset.cartUpdateError;
            }
          } catch (_refreshError) {
            enhanced = false;
            form.classList.remove('neptune-cart__form--enhanced');
            form.removeAttribute('aria-busy');
            form.querySelectorAll('[data-cart-pending]').forEach((row) => row.removeAttribute('data-cart-pending'));
            form.querySelectorAll('input[name="updates[]"]').forEach((input) => { input.value = input.defaultValue; input.disabled = false; });
            form.querySelectorAll('.neptune-cart__stepper button').forEach((button) => { button.disabled = button.dataset.cartStep === '-1' && Number(button.parentElement.querySelector('input').value) <= 1; });
            if (checkout) checkout.disabled = false;
            setStatus(root.dataset.cartUpdateError, true);
          }
        }
      };

      const queue = (row, quantity, immediate = false) => {
        if (!row || inFlight) return;
        pending.set(Number(row.dataset.cartLine), quantity);
        if (checkout) checkout.disabled = true;
        setStatus(root.dataset.cartUpdating);
        clearTimeout(timer);
        timer = setTimeout(flush, immediate ? 0 : 320);
      };

      form.addEventListener('click', (event) => {
        if (!enhanced) return;
        const step = event.target.closest('[data-cart-step]');
        if (step && !step.disabled) {
          const input = step.parentElement.querySelector('input[name="updates[]"]');
          const quantity = Math.max(1, (Number.parseInt(input.value, 10) || 1) + Number(step.dataset.cartStep));
          input.value = quantity;
          step.parentElement.querySelector('[data-cart-step="-1"]').disabled = quantity <= 1;
          queue(step.closest('[data-cart-line]'), quantity);
          return;
        }
        const remove = event.target.closest('.neptune-cart__remove');
        if (remove) {
          event.preventDefault();
          if (!inFlight) queue(remove.closest('[data-cart-line]'), 0, true);
        }
      });

      form.addEventListener('change', (event) => {
        if (!enhanced) return;
        if (!event.target.matches('input[name="updates[]"]')) return;
        const input = event.target;
        input.value = Math.max(1, Number.parseInt(input.value, 10) || 1);
        input.parentElement.querySelector('[data-cart-step="-1"]').disabled = Number(input.value) <= 1;
        queue(input.closest('[data-cart-line]'), Number(input.value));
      });

      form.addEventListener('keydown', (event) => {
        if (!enhanced) return;
        if (event.key !== 'Enter' || !event.target.matches('input[name="updates[]"]')) return;
        event.preventDefault();
        event.target.dispatchEvent(new Event('change', { bubbles: true }));
        flush();
      });

      form.addEventListener('submit', (event) => {
        if (!enhanced) return;
        if (event.submitter?.name === 'checkout' && !inFlight && pending.size === 0) return;
        event.preventDefault();
        flush();
      });
    };

    const root = document.querySelector('.neptune-cart');
    if (root) initializeCart(root);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["countdown"] && !Shopify.designMode) return;
  try {
    
  const initCountdown = (root) => {
    if (root.dataset.countdownInitialized === 'true') return;
    root.dataset.countdownInitialized = 'true';
    const clock = root.querySelector('.countdown__clock');
    if (!clock) return;
    const end = Date.parse(root.dataset.end);
    if (!Number.isFinite(end)) { clock.hidden = true; return; }
    const parts = clock.querySelectorAll('[data-part]');
    let timer;
    const update = () => {
      const left = Math.max(0, end - Date.now());
      if (left === 0) {
        clearInterval(timer);
        clock.classList.add('is-expired');
        clock.setAttribute('role', 'status');
        clock.setAttribute('aria-live', 'polite');
        clock.removeAttribute('aria-label');
        clock.textContent = root.dataset.expiredMessage;
        return;
      }
      const values = [Math.floor(left / 86400000), Math.floor(left / 3600000) % 24, Math.floor(left / 60000) % 60, Math.floor(left / 1000) % 60];
      parts.forEach((part, index) => { part.textContent = String(values[index]).padStart(2, '0'); });
    };
    update();
    if (clock.getAttribute('role') === 'timer') timer = setInterval(update, 1000);
  };
  document.querySelectorAll('[data-countdown]').forEach(initCountdown);
  document.addEventListener('shopify:section:load', (event) => event.target.querySelectorAll('[data-countdown]').forEach(initCountdown));

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["media-hero"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const motion = window.matchMedia('(prefers-reduced-motion: reduce)');
    const mobile = window.matchMedia('(max-width: 749px)');
    const initialize = (root) => {
      if (root.dataset.ready === 'true') return;
      root.dataset.ready = 'true';
      const slides = [...root.querySelectorAll('[data-media-slide]')];
      if (!slides.length) return;
      const dots = [...root.querySelectorAll('[data-media-dot]')];
      const pauseButton = root.querySelector('[data-media-pause]');
      let current = 0;
      let timer;
      let transitionTimer;
      let paused = false;
      const autoplay = root.dataset.autoplay === 'true';
      const interval = Number(root.dataset.interval) || 7000;
      const visibleVideo = (slide) => {
        const surface = slide.querySelector(mobile.matches ? '.media-hero__media--mobile' : '.media-hero__media--desktop');
        const template = surface?.querySelector('[data-media-video]');
        if (template) {
          surface.append(template.content.cloneNode(true));
          template.remove();
        }
        return surface?.querySelector('video');
      };
      const stopVideos = () => root.querySelectorAll('video').forEach((video) => video.pause());
      const clearTimer = () => window.clearTimeout(timer);
      const updatePauseButton = () => {
        if (!pauseButton) return;
        pauseButton.setAttribute('aria-pressed', String(paused));
        pauseButton.setAttribute('aria-label', paused ? pauseButton.dataset.playLabel : pauseButton.dataset.pauseLabel);
      };
      const schedule = () => {
        clearTimer();
        if (autoplay && !paused && !motion.matches && !document.hidden && !root.matches(':hover') && !root.contains(document.activeElement) && slides.length > 1) {
          const duration = Number(slides[current].dataset.duration) || interval;
          timer = window.setTimeout(() => show((current + 1) % slides.length), duration);
        }
      };
      const playVideo = () => {
        stopVideos();
        const slide = slides[current];
        const video = visibleVideo(slide);
        if (!video || paused || motion.matches || document.hidden) return;
        const start = Number(slide.dataset[mobile.matches ? 'mobileStart' : 'desktopStart']) || 0;
        const end = Number(slide.dataset[mobile.matches ? 'mobileEnd' : 'desktopEnd']) || 0;
        let clipStart = start;
        const begin = () => {
          if (paused || slides[current] !== slide || visibleVideo(slide) !== video || motion.matches || document.hidden) return;
          clipStart = Number.isFinite(video.duration) && start < video.duration ? start : 0;
          video.currentTime = clipStart;
          video.play().catch(() => {});
        };
        if (video.readyState >= 1) begin();
        else { video.addEventListener('loadedmetadata', begin, { once: true }); video.load(); }
        video.ontimeupdate = () => {
          if (end > clipStart && video.currentTime >= end) {
            if (autoplay && !paused && slides.length > 1) show((current + 1) % slides.length);
            else { video.currentTime = clipStart; video.play().catch(() => {}); }
          }
        };
        video.onended = () => {
          if (autoplay && !paused && slides.length > 1) show((current + 1) % slides.length);
          else { video.currentTime = clipStart; video.play().catch(() => {}); }
        };
      };
      const show = (index) => {
        const next = (index + slides.length) % slides.length;
        window.clearTimeout(transitionTimer);
        if (next !== current && !motion.matches) {
          slides.forEach((slide, position) => {
            if (position !== current && position !== next) {
              slide.hidden = true;
              slide.classList.remove('is-active', 'is-leaving');
            }
          });
          const previousSlide = slides[current];
          const nextSlide = slides[next];
          nextSlide.hidden = false;
          nextSlide.classList.remove('is-active', 'is-leaving');
          nextSlide.getBoundingClientRect();
          previousSlide.classList.remove('is-active');
          previousSlide.classList.add('is-leaving');
          nextSlide.classList.add('is-active');
          transitionTimer = window.setTimeout(() => {
            if (!previousSlide.classList.contains('is-active')) previousSlide.hidden = true;
            previousSlide.classList.remove('is-leaving');
          }, 650);
        } else {
          slides.forEach((slide, position) => {
            slide.hidden = position !== next;
            slide.classList.toggle('is-active', position === next);
            slide.classList.remove('is-leaving');
          });
        }
        current = next;
        dots.forEach((dot, position) => {
          if (position === current) dot.setAttribute('aria-current', 'true');
          else dot.removeAttribute('aria-current');
        });
        playVideo();
        schedule();
      };
      root.querySelector('[data-media-previous]')?.addEventListener('click', () => show(current - 1));
      root.querySelector('[data-media-next]')?.addEventListener('click', () => show(current + 1));
      dots.forEach((dot) => dot.addEventListener('click', () => show(Number(dot.dataset.mediaDot))));
      pauseButton?.addEventListener('click', () => {
        paused = !paused;
        updatePauseButton();
        if (paused) stopVideos(); else playVideo();
        schedule();
      });
      root.addEventListener('mouseenter', clearTimer);
      root.addEventListener('mouseleave', schedule);
      root.addEventListener('focusin', clearTimer);
      root.addEventListener('focusout', (event) => { if (!root.contains(event.relatedTarget)) schedule(); });
      document.addEventListener('visibilitychange', () => { if (document.hidden) { clearTimer(); stopVideos(); } else show(current); });
      mobile.addEventListener('change', () => show(current));
      motion.addEventListener('change', () => show(current));
      document.addEventListener('shopify:block:select', (event) => {
        const index = slides.findIndex((slide) => slide.contains(event.target) || slide === event.target);
        if (index >= 0) { paused = true; updatePauseButton(); show(index); }
      });
      show(0);
    };
    const initializeAll = () => document.querySelectorAll('[data-media-hero]').forEach(initialize);
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initializeAll);
    else initializeAll();
    document.addEventListener('shopify:section:load', initializeAll);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["password"]) return;
  try {
    
  document.addEventListener('change', (event) => {
    if (!event.target.matches('#PasswordLanguage')) return;
    const locale = event.target.value;
    const currentLocale = document.documentElement.lang;
    const url = new URL(window.location.href);
    const parts = url.pathname.split('/').filter(Boolean);
    if (parts[0] === currentLocale) parts.shift();
    url.pathname = (locale === 'en' ? '' : '/' + locale) + '/' + parts.join('/');
    window.location.assign(url.toString());
  });
  const initializeCountdowns = (root) => {
    root.querySelectorAll('[data-maintenance-countdown]').forEach((clock) => {
      if (clock.dataset.countdownInitialized === 'true') return;
      clock.dataset.countdownInitialized = 'true';
      const end = Date.parse(clock.dataset.maintenanceCountdown);
      if (!Number.isFinite(end)) { clock.textContent = clock.dataset.expiredMessage; return; }
      const units = ['days', 'hours', 'minutes', 'seconds'].map((unit) => clock.querySelector('[data-countdown-' + unit + ']'));
      let timer;
      const update = () => {
        if (!clock.isConnected) { clearInterval(timer); return; }
        const left = Math.max(0, end - Date.now());
        if (left === 0) { clearInterval(timer); clock.textContent = clock.dataset.expiredMessage; return; }
        const values = [Math.floor(left / 86400000), Math.floor(left / 3600000) % 24, Math.floor(left / 60000) % 60, Math.floor(left / 1000) % 60];
        units.forEach((unit, index) => { if (unit) unit.textContent = String(values[index]).padStart(2, '0'); });
      };
      update();
      if (end > Date.now()) timer = setInterval(update, 1000);
    });
  };
  initializeCountdowns(document);
  document.addEventListener('shopify:section:load', (event) => initializeCountdowns(event.target));

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-recommendations"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('product-recommendations')) {
    customElements.define('product-recommendations', class extends HTMLElement {
      connectedCallback() {
        if (this.dataset.loaded === 'true') return;
        if ('IntersectionObserver' in window) {
          this.visibilityObserver = new IntersectionObserver((entries) => {
            if (!entries.some((entry) => entry.isIntersecting)) return;
            this.visibilityObserver.disconnect();
            this.loadRecommendations();
          }, { rootMargin: '400px' });
          this.visibilityObserver.observe(this.parentElement);
        } else this.loadRecommendations();
      }
      loadRecommendations() {
        if (!this.isConnected || this.dataset.loaded === 'true') return;
        this.dataset.loaded = 'true';
        this.requestController = new AbortController();
        this.requestTimeout = setTimeout(() => this.requestController.abort(), 10000);
        const placeholder = this.querySelector('[data-recommendation-skeleton]');
        if (placeholder) {
          this.loadingTimer = setTimeout(() => {
            if (!this.isConnected) return;
            this.append(placeholder.content.cloneNode(true));
            this.hidden = false;
            this.setAttribute('aria-busy', 'true');
          }, 120);
        }
        fetch(this.dataset.url, { signal: this.requestController.signal })
          .then((response) => { if (!response.ok) throw new Error('Recommendations unavailable'); return response.text(); })
          .then((text) => {
            const content = new DOMParser().parseFromString(text, 'text/html').querySelector('product-recommendations');
            if (this.isConnected && content?.querySelector('[data-recommendation-source="shopify"]')) { this.innerHTML = content.innerHTML; this.hidden = false; }
          })
          .catch(() => {})
          .finally(() => {
            clearTimeout(this.loadingTimer);
            clearTimeout(this.requestTimeout);
            this.removeAttribute('aria-busy');
            this.querySelector('[data-recommendation-placeholder]')?.remove();
            this.querySelector('[data-recommendation-status]')?.remove();
            if (!this.querySelector('[data-recommendation-source]')) this.hidden = true;
          });
      }
      disconnectedCallback() {
        this.visibilityObserver?.disconnect();
        clearTimeout(this.loadingTimer);
        clearTimeout(this.requestTimeout);
        this.requestController?.abort();
        delete this.dataset.loaded;
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["store-visit"]) return;
  try {
    
  (() => {
    const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
    const initialize = (section) => {
      const tour = section.querySelector('[data-store-tour]');
      if (tour && tour.dataset.ready !== 'true') {
        const video = tour.querySelector('video');
        const toggle = tour.querySelector('[data-store-tour-toggle]');
        if (video && toggle) {
          tour.dataset.ready = 'true';
          video.muted = true;
          video.controls = false;
          toggle.hidden = false;
          let inView = false;
          let userPaused = false;
          const syncToggle = () => {
            toggle.setAttribute('aria-pressed', String(video.paused));
            toggle.setAttribute('aria-label', video.paused ? toggle.dataset.playLabel : toggle.dataset.pauseLabel);
          };
          video.addEventListener('play', syncToggle);
          video.addEventListener('pause', syncToggle);
          toggle.addEventListener('click', () => {
            userPaused = !video.paused;
            if (!userPaused) video.play().catch(syncToggle);
            else video.pause();
          });
          const syncPlayback = () => {
            if (inView && !document.hidden && !userPaused && !reducedMotion.matches) video.play().catch(syncToggle);
            else video.pause();
          };
          if ('IntersectionObserver' in window) {
            const visibilityObserver = new IntersectionObserver((entries) => {
              inView = entries.some((entry) => entry.isIntersecting);
              syncPlayback();
            }, { rootMargin: '200px' });
            visibilityObserver.observe(tour);
            section.addEventListener('shopify:section:unload', () => visibilityObserver.disconnect(), { once: true });
          } else { inView = true; syncPlayback(); }
          document.addEventListener('visibilitychange', syncPlayback);
          section.addEventListener('shopify:section:unload', () => {
            document.removeEventListener('visibilitychange', syncPlayback);
            video.pause();
          }, { once: true });
          syncToggle();
        }
      }
      const root = section.querySelector('[data-store-gallery]');
      if (!root || root.dataset.ready === 'true') return;
      root.dataset.ready = 'true';
      const track = root.querySelector('[data-store-gallery-track]');
      const items = [...root.querySelectorAll('[data-store-image]')];
      const previous = root.querySelector('[data-store-previous]');
      const next = root.querySelector('[data-store-next]');
      const counter = root.querySelector('[data-store-counter]');
      let mobileIndex = 0;
      let scrollFrame;

      const updateMobile = (index) => {
        mobileIndex = Math.max(0, Math.min(index, items.length - 1));
        if (counter) counter.textContent = `${mobileIndex + 1} / ${items.length}`;
        if (previous) previous.disabled = mobileIndex === 0;
        if (next) next.disabled = mobileIndex === items.length - 1;
      };
      const moveMobile = (index) => {
        updateMobile(index);
        items[mobileIndex].scrollIntoView({ behavior: reducedMotion.matches ? 'auto' : 'smooth', block: 'nearest', inline: 'center' });
      };
      previous?.addEventListener('click', () => moveMobile(mobileIndex - 1));
      next?.addEventListener('click', () => moveMobile(mobileIndex + 1));
      track.addEventListener('scroll', () => {
        window.cancelAnimationFrame(scrollFrame);
        scrollFrame = window.requestAnimationFrame(() => {
          const center = track.getBoundingClientRect().left + track.clientWidth / 2;
          const nearest = items.reduce((best, item, index) => {
            const bounds = item.getBoundingClientRect();
            const distance = Math.abs(bounds.left + bounds.width / 2 - center);
            return distance < best.distance ? { index, distance } : best;
          }, { index: 0, distance: Infinity });
          updateMobile(nearest.index);
        });
      }, { passive: true });

    };
    const initializeAll = () => document.querySelectorAll('.store-visit').forEach(initialize);
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initializeAll);
    else initializeAll();
    document.addEventListener('shopify:section:load', initializeAll);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["travel-guide"]) return;
  try {
    
  (() => {
    const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
    const sync = (hero) => {
      const video = hero.querySelector('video');
      const button = hero.querySelector('[data-travel-video-toggle]');
      if (!video || !button) return;
      button.hidden = reducedMotion.matches;
      button.setAttribute('aria-pressed', String(video.paused));
      button.setAttribute('aria-label', video.paused ? button.dataset.playLabel : button.dataset.pauseLabel);
    };
    const playback = (hero) => {
      const video = hero.querySelector('video');
      if (!video) return;
      if (reducedMotion.matches || document.hidden || hero.dataset.userPaused === 'true') video.pause();
      else video.play().catch(() => sync(hero));
      sync(hero);
    };
    const initialize = () => document.querySelectorAll('[data-travel-hero]').forEach((hero) => {
      const video = hero.querySelector('video');
      const button = hero.querySelector('[data-travel-video-toggle]');
      if (!video || !button || hero.dataset.videoInitialized) return;
      hero.dataset.videoInitialized = 'true';
      video.muted = true;
      video.addEventListener('play', () => sync(hero));
      video.addEventListener('pause', () => sync(hero));
      button.addEventListener('click', () => {
        hero.dataset.userPaused = String(!video.paused);
        playback(hero);
      });
      playback(hero);
    });
    const updatePlayback = () => document.querySelectorAll('[data-travel-hero]').forEach(playback);
    reducedMotion.addEventListener('change', updatePlayback);
    document.addEventListener('visibilitychange', updatePlayback);
    document.addEventListener('shopify:section:load', initialize);
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initialize, { once: true });
    else initialize();
  })();

  } catch(e) { console.error(e); }
})();
})();
